module.exports = __webpack_public_path__ + "static/media/target-goal-white.c9ec61f6.svg";